<template>
  <div>
    <section class="hero is-primary is-bod is-medium custom-background-color">

      <!-- Hero content: will be in the middle -->
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">
            ReferenceKit Ordering
          </h1>
          <h2 class="subtitle">
            Overview
          </h2>
        </div>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <div class="hero-foot">
        <nav class="tabs is-boxed is-fullwidth">
          <div class="container">
            <ul>
              <router-link active-class="is-active" tag="li" :to="{name: 'Overview'}" exact><a>Overview</a></router-link>
              <router-link active-class="is-active" tag="li" :to="{name: 'Orders'}" exact><a>Orders</a></router-link>
              <router-link active-class="is-active" tag="li" :to="{name: 'DeliveredMaterial'}" exact><a>Delivered Material</a></router-link>
            </ul>
          </div>
        </nav>
      </div>
    </section>

    <!-- Router view for hero tabs -->
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
// @ is an alias to /src
const DEFAULT_TRANSITION = 'fade';

export default {
  name: 'Home',
  data: function() {
    return {
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION
    }
  }
}
</script>

<style scoped>
.custom-background-color {
  background: rgb(3,120,255);
  background: -moz-linear-gradient(90deg, rgba(3,120,255,1) 0%, rgba(6,103,232,1) 30%, rgba(46,72,232,1) 50%, rgba(65,37,235,1) 65%, rgba(110,56,255,1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(3,120,255,1) 0%, rgba(6,103,232,1) 30%, rgba(46,72,232,1) 50%, rgba(65,37,235,1) 65%, rgba(110,56,255,1) 100%);
  background: linear-gradient(90deg, rgba(3,120,255,1) 0%, rgba(6,103,232,1) 30%, rgba(46,72,232,1) 50%, rgba(65,37,235,1) 65%, rgba(110,56,255,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#0378ff",endColorstr="#6e38ff",GradientType=1);
}
/* Safari tab fix */
.hero.is-primary .tabs.is-boxed li.is-active a, .hero.is-primary .tabs.is-boxed li.is-active, .hero.is-primary .tabs.is-toggle li.is-active a, .hero.is-primary .tabs.is-toggle li.is-active {
  color: #7957d5;
}
</style>
